export const authTypes = {
  SAVE_PROFILE_DATA : "[PROFILE] SAVE_DATA",
  REMOVE_PROFILE_DATA : "[PROFILE] REMOVE_DATA",
  UPDATE_PROFILE_DATA : "[PROFILE] UPDATE_DATA",
  SET_PROFILE_LOADING_STATUS : "[PROFILE] SET_LOADING_STATUS",
  FORGOT_PASSWORD_SUCCESS: '[PROFILE] FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_CODE_SUCCESS: '[PROFILE] FORGOT_PASSWORD_CODE_SUCCESS',
  RESET_PASSWORD_SUCCESS: '[PROFILE] RESET_PASSWORD_SUCCESS',
}
